module.exports = __webpack_public_path__ + "img/frame (189).e66df341.jpg";